"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uuid = require("uuid");
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
var _excluded = ["type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var _createNode = function createNode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref.type,
    value = _ref.value,
    level = _ref.level,
    marks = _ref.marks;
  var markDefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if ((0, _fp.isNil)(value)) {
    return null;
  }
  var determinedType = type || ((0, _fp.isString)(value) ? 'span' : 'block');
  if (determinedType === 'portableText') {
    return value;
  }
  if (determinedType === 'list') {
    return (0, _fp.compact)((0, _fp.map)(function (item) {
      return _createNode({
        level: item.level,
        type: 'listItem',
        value: [item]
      });
    }, value));
  }
  var output = {
    _key: (0, _uuid.v4)(),
    _type: determinedType // block, span, etc
  };
  var childMarkDefs = [];
  if (determinedType === 'listItem') {
    // eslint-disable-next-line no-underscore-dangle
    output._type = 'block';
    output.level = level || 1;
    output.listItem = 'bullet';
  }
  if (/^h[1-6]$/.test(determinedType)) {
    // eslint-disable-next-line no-underscore-dangle
    output._type = 'block';
    output.style = type;
  }

  // eslint-disable-next-line no-underscore-dangle
  if (output._type === 'block') {
    if ((0, _fp.isArray)(value)) {
      output.children = (0, _lodash["default"])(value).flatMap(function (item) {
        return _createNode(item, childMarkDefs);
      }).compact().value();
    } else if ((0, _fp.isString)(value)) {
      output.children = [_createNode({
        type: 'span',
        value: value,
        marks: marks
      }, childMarkDefs)];
    } else {
      output.children = (0, _fp.compact)([_createNode(value, childMarkDefs)]);
    }
  } else {
    output.text = value;
  }
  if (!(0, _fp.isEmpty)(marks)) {
    output.marks = (0, _fp.map)(function (mark) {
      if ((0, _fp.isString)(mark)) {
        return mark;
      }
      var markKey = (0, _uuid.v4)();
      var _type = mark.type,
        rest = _objectWithoutProperties(mark, _excluded);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      markDefs.push(_objectSpread({
        _type: _type,
        _key: markKey
      }, rest));
      return markKey;
    }, marks);
  }
  if (!(0, _fp.isEmpty)(childMarkDefs)) {
    output.markDefs = childMarkDefs;
  }
  return output;
};
var generatePortableText = function generatePortableText(content) {
  return (0, _fp.isArray)(content) ? _lodash["default"].flatMap(content, (0, _fp.ary)(1, _createNode)) : _createNode(content);
};
var _default = exports["default"] = generatePortableText;
module.exports = exports.default;